import React from "react";
import { useHistory } from "react-router-dom";
import { Heading, ProgressBar, grayBase, grayDark600, tealBase, tealLightest } from "@RooUI";

import HeaderLogIn from "../Login/HeaderLogIn";

import {
  Breadcrumb,
  HeadingContainer,
  LeftContainer,
  LeftContainerInner,
  PageContainer,
  ProgressBarContainer,
  RightContainer,
} from "./styles";

function RegistrationPage({
  rightContainerContent,
  leftContainerContent,
  progressBarPercent,
  title,
  subtitle,
  previousPage,
  showLogout = false,
  showProgress = true,
}: {
  rightContainerContent: React.ReactNode;
  leftContainerContent: React.ReactNode;
  progressBarPercent?: number;
  title: string;
  subtitle?: string;
  previousPage?: { title: string; pathname: string };
  showLogout?: boolean;
  showProgress?: boolean;
}) {
  const history = useHistory();
  return (
    <PageContainer className="inner-container">
      <HeaderLogIn showLogout={showLogout} />
      <LeftContainer $progress={showProgress}>
        {previousPage?.title && (
          <Breadcrumb
            onClick={() => history.push(previousPage.pathname)}
            icon="ArrowBack"
            iconPosition="left"
          >{`Back to ${previousPage.title}`}</Breadcrumb>
        )}
        {showProgress && (
          <ProgressBarContainer className={previousPage?.title ? "breadcrumb-spacing" : ""}>
            <ProgressBar
              data-testid="progressBar"
              percent={progressBarPercent}
              strokeColor={tealBase}
              trailColor={tealLightest}
              strokeWidth={12}
            />
          </ProgressBarContainer>
        )}
        <LeftContainerInner $progress={showProgress} className="left-container-content">
          <HeadingContainer $progress={showProgress}>
            <Heading level={2} color={grayBase}>
              {title}
            </Heading>
            {subtitle && (
              <Heading level={3} color={grayDark600}>
                {subtitle}
              </Heading>
            )}
          </HeadingContainer>
          {leftContainerContent}
        </LeftContainerInner>
      </LeftContainer>
      <RightContainer>{rightContainerContent}</RightContainer>
    </PageContainer>
  );
}

// eslint-disable-next-line no-restricted-exports
export default RegistrationPage;
